import React from 'react';

import EmptyListIlustration from '../../assets/images/healthscan-empty-list-warning-illustration.svg';
import { EmptyListWarningStyle } from './EmptyListWarningStyle';
import { noSearchResultMessageShape } from '../../utils/propTypesShapes';

const EmptyListWarning = ({ messages }) => {
  return (
    <EmptyListWarningStyle>
      <div className="container">
        <span className="first-message">{messages.firstMessage}</span>
        <span className="second-message">{messages.secondMessage}</span>
        <img
          className="no-result-image"
          src={EmptyListIlustration}
          alt="No re234234sults"
        />
      </div>
    </EmptyListWarningStyle>
  );
};

EmptyListWarning.propTypes = {
  messages: noSearchResultMessageShape,
};

EmptyListWarning.defaultProps = {
  messages: {},
};
export default EmptyListWarning;
